import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface Snowflake {
  id: number;
  x: number;
  y: number;
  size: number;
  duration: number;
  delay: number;
}
export function SnowfallEffect() {
  const [snowflakes, setSnowflakes] = useState<Snowflake[]>([]);
  useEffect(() => {
    // Generate random snowflakes on client side only to avoid hydration mismatch
    const count = 50;
    const newSnowflakes: Snowflake[] = [];
    for (let i = 0; i < count; i++) {
      newSnowflakes.push({
        id: i,
        x: Math.random() * 100,
        y: -20,
        size: Math.random() * 4 + 2,
        duration: Math.random() * 10 + 10,
        delay: Math.random() * 10 // 0-10s delay
      });
    }
    setSnowflakes(newSnowflakes);
  }, []);
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-131">
      {snowflakes.map(flake => <motion.div key={flake.id} className="absolute rounded-full bg-white/60 blur-[1px]" style={{
      left: `${flake.x}%`,
      width: flake.size,
      height: flake.size
    }} initial={{
      y: -20,
      opacity: 0
    }} animate={{
      y: '110vh',
      opacity: [0, 1, 1, 0],
      x: [`${flake.x}%`, `${flake.x + (Math.random() * 10 - 5)}%`, `${flake.x}%`]
    }} transition={{
      duration: flake.duration,
      repeat: Infinity,
      delay: flake.delay,
      ease: 'linear',
      times: [0, 0.1, 0.9, 1]
    }} data-id="element-132" />)}
    </div>;
}